const appTheme = process.env.REACT_APP_THEME;

export const appPalette = {
  colors: {
    acura_red: '#e82c2a',
    acura_red_o007: 'rgba(232,13,13,0.07)',
    blue: '#004e9a',
    blue_dark: '#293859',
    blue_light: '#0f396b',
    blue_light_o05: 'rgb(15, 57, 107, 0.05)',
    blue_malibu: '#62C7FF',
    black: '#000000',
    black_o07: 'rgba(0,0,0,0.7)',
    black_o01: 'rgba(0,0,0,0.1)',
    warm_grey: '#6f6f6f',
    dark_grey_1: '#1e2123',
    dark_grey_2: '#313131',
    dark_grey_3: '#2b2e2f',
    dark_grey_4: '#5a5a5a',
    mid_grey: '#707070',
    mid_grey_2: '#949494',
    mid_grey_3: '#e8e8e8',
    light_grey_1: '#b5b5b5',
    light_grey_2: '#cdcdcd',
    light_grey_3: '#dedede',
    light_grey_4: '#5e6162',
    light_grey_5: '#808080',
    light_grey_6: '#5d6061',
    light_grey_7: '#d5d5d5',
    off_white: '#f3f3f3',
    mid_white: '#FBFBFB',
    green: '#1e9b00',
    white: '#ffffff',
    honda_blue: '#007cc0',
    honda_red: '#E42525',
    dark_blue_1: '#00324f',
    mid_blue_1: '#00446B',
    honda_off_white: '#f2f2f2',
    honda_mid_grey: '#f5f5f5',
    iconMainColor: appTheme === 'honda' ? '#007cc0' : '#e82c2a',
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
};
